export function arrayBufferToBase64(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  return btoa(
    Array.from(bytes)
      .map((byte) => String.fromCharCode(byte))
      .join(''),
  );
}
